export default __webpack_public_path__ + "static/media/home-decor-img-07.ca1076a4.png";